import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import CardPreview from './CardPreview';
import CardControls from './CardControls';

const CardGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.CARD]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.CARD, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.CARD, newConfig);
  };

  const mode = config.mode || 'card';
  const title = mode === 'fullUI' ? 'SwiftUI Builder' : 'UI Builder';

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">{title}</h2>
      <CardControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const CardPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.CARD]);
  return <CardPreview config={config} />;
};

export default CardGenerator;

